import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the CommunicationNewMobile state domain
 */

export const selectCommunicationDetailMobileDomain = state =>
  state.CommunicationNewMobile || initialState;

/**
 * Other specific selectors
 */

export const makeSelectFirstRender = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.firstRender,
  );
export const makeSelectItemDetail = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.itemDetail,
  );

// update
export const makeSelectUpdateLoading = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.updateLoading,
  );
export const makeSelectUpdateSuccess = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.updateSuccessful,
  );
export const makeSelectUpdateError = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate.updateError,
  );

/**
 * Default selector used by Communication
 */

const makeSelectCommunicationDetailMobile = () =>
  createSelector(
    selectCommunicationDetailMobileDomain,
    substate => substate,
  );

export default makeSelectCommunicationDetailMobile;